module.exports = __webpack_public_path__ + "img/driverLicence.3718a7a5.jpg";